import defaultSettings from '@/settings/settings'
import Storage from '@/utils/storage'

const { showSettings, tagsView, fixedHeader, sidebarLogo, themeList } = defaultSettings

const settingStore = Storage.getItem('settings') || {}


const getDefaultState = () => {
  return {
    showSettings: settingStore.showSettings || showSettings,
    tagsView: settingStore.tagsView || tagsView,
    fixedHeader: settingStore.fixedHeader || fixedHeader,
    sidebarLogo: settingStore.sidebarLogo || sidebarLogo,
    themeList: themeList
  }
}

const state = getDefaultState()

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
    Storage.setItem('settings', state)
  },
  RESET_STORE: (state) => {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

